import axios from "../utils/axios.js";
import {BACKEND_URL} from "@/constants/globalConstants";


export async function stopJob (id: string): Promise<void> {
    const response = await axios.post(`/job/stopJob/${id}`);
    return response;
}

export async function getRunningIngestionJobs(): Promise<any[]> {
    const response = await axios.get(`/job/runningIngestionJobs`);
    return response.data;
}

export async function createIngestionJob(body: object): Promise<any> {
    const response = await axios.post('/job/ingestion', body);
    return response.data;
}

export async function createAnalysisJob(body: object): Promise<any> {
    const response = await axios.post('/job/analysis', body);
    return response.data;
}

export async function updateJob(id: string, body: object): Promise<any> {
    const response = await axios.put(`/job/updateJob/${id}`, body);
    return response.data;
}

export async function deleteJob(id: string): Promise<void> {
    await axios.delete(`/job/deleteJob/${id}`);
}

export async function startJob(id: string): Promise<any> {
    const response = await axios.post('/match/startJob', { idJob: id });
    return response.data;
}